"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderDynamicList = exports.renderMeatsName = exports.renderBreadName = void 0;
var state_1 = __importDefault(require("../state/state"));
var renderBreadName = function () {
    var $listStaticBread = document.querySelector('.list-static__bread > span');
    var breadName = state_1.default.selectedItem.find(function (item) { return /bread/.test(item.id); });
    $listStaticBread.textContent = breadName ? breadName.name : '';
};
exports.renderBreadName = renderBreadName;
var renderMeatsName = function () {
    var $listStaticMeats = document.querySelector('.list-static__meats > span');
    var meatsName = state_1.default.selectedItem.find(function (item) { return /meats/.test(item.id); });
    $listStaticMeats.textContent = meatsName ? meatsName.name : '';
};
exports.renderMeatsName = renderMeatsName;
var renderDynamicList = function () {
    var $checkedItemList = document.querySelector('.custom__list-dynamic');
    $checkedItemList.innerHTML = '';
    state_1.default.selectedItem.forEach(function (item) {
        if (item.id.includes('bread') || item.id.includes('meats'))
            return;
        $checkedItemList.innerHTML += "<li class=\"list-dynamic__item\">\n  <input type=\"number\" id=\"selected-".concat(item.id, "\" class=\"list-dynamic__num\" value=\"").concat(item.quantity, "\" min=\"1\" max=\"10\" />\n  <label for=\"selected-").concat(item.id, "\">").concat(item.name, "</label>\n  <button class=\"list-dynamic__del\"><i class=\"fas fa-times-circle\"></i></button>\n</li>");
    });
    if (!$checkedItemList.firstElementChild)
        $checkedItemList.innerHTML = "<i class=\"far fa-grin\"></i>\n  <span>What's your way?</span>";
};
exports.renderDynamicList = renderDynamicList;
